import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';

export const metaOverrideSet = buildBaseOverrides()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('name', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md' },
  }, overrideReadOnly);
